app.controller('OrderTransferController', ['$rootScope', '$scope', '$state', '$stateParams', function ($rootScope, $scope, $state, $stateParams) {

    $scope.order_id = $stateParams.order_id;

    $scope.waiting_for_data = !!$scope.order_id;

    $scope.visible_order = null;

    $scope.view_model = {
        form_disabled: false,
    }

    if ($scope.waiting_for_data) {
        $rootScope.service.account.requireMinimumData(function () {
            $rootScope.service.order.requestOrder($scope.order_id, function (success, order) {
                console.log("order****")
                console.log(order)
               // const canTransfer = !!order && !!order._manual_entry_order;
                const canTransfer = true;
                //const canTransfer = !!order;

                $scope.visible_order = success && canTransfer ? order : null;
                $scope.waiting_for_data = false;

            })
        });
    }

    $scope.acceptTransfer = function (validateFormCallback) {

        $scope.view_model.form_disabled = true;
        $rootScope.service.order.acceptTransfer($scope.order_id, function (success, data, messages) {
            $scope.view_model.form_disabled = false;
            validateFormCallback(success, messages);
            if(success){
                $rootScope.service.tracking.track_event("Checkout", "Started from staff transfer");
                for(let line of $scope.visible_order.lines ?? []){
                    line.transferred_from_staff = true;
                }
                $rootScope.service.order.setCurrentOrder($scope.visible_order);
                $state.go('myba.order-checkout');
            }
        })

    };

    $scope.rejectTransfer = function (validateFormCallback) {

        $scope.view_model.form_disabled = true;
        $rootScope.service.order.rejectTransfer($scope.order_id, function (success, data, messages) {
            $scope.view_model.form_disabled = false;
            validateFormCallback(success, messages);
            if(success){
                $state.go('myba.dashboard');
            }
        })

    };

}]);